import { render, staticRenderFns } from "./leaveMngData.vue?vue&type=template&id=6e53d2cd&"
import script from "./leaveMngData.vue?vue&type=script&lang=js&"
export * from "./leaveMngData.vue?vue&type=script&lang=js&"
import style0 from "./leaveMngData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports